import React, { useReducer } from "react";
import axios from "axios";
import MenuContext from "./menuContext";
import menuReducer from "./menuReducer";
import { GET_MENU, MENU_ERROR } from "../types";

const MenuState = props => {
  const initialState = {
    menu: null,
    error: null
  };

  const [state, dispatch] = useReducer(menuReducer, initialState);

  // Get Menus
  const getMenu = async () => {
    try {
      const res = await axios.get(process.env.REACT_APP_API_URL + "/api/menu");
      dispatch({
        type: GET_MENU,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: MENU_ERROR,
        payload: err.response.msg
      });
    }
  };

  return (
    <MenuContext.Provider
      value={{
        menu: state.menu,
        error: state.error,
        getMenu
      }}
    >
      {props.children}
    </MenuContext.Provider>
  );
};

export default MenuState;
